import axios from 'axios';

const TIMEOUT_GENERAL = 600000; // 10 min
const CALL = "TUBITAK";
const management_method = "";
const BASEURL = process.env.REACT_APP_WRITER_BASEURL;

export const createProject = async (user_idx, idea_idx, name, method, keywords, priority_text, wp_list, publications_list) => {
  const token = localStorage.getItem('authToken');
  try {
    const res = await axios.post(
      `${BASEURL}/create_new_project`,
      {
        user_idx: user_idx,
        idea_idx: idea_idx,
        call: CALL,
        name: name,
        method: method,
        keywords: keywords,
        priority_text: priority_text,
        wp_list: wp_list,
        publications_list: publications_list,
        management_method: management_method,
      },
      {
        timeout: TIMEOUT_GENERAL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data.project_idx;
  } catch (error) {
    // Forward the full error so it can be handled outside
    if (error.response) {
      throw error; // Contains status and message
    } else {
      throw new Error("Network or server error occurred");
    }
  }
};


export const saveProjectDate = async (project_idx, start_date, duration) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

    const res = await axios.post(`${BASEURL}/save_project_date`, 
        { project_idx:project_idx, start_date:start_date, duration:duration }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });
    return res.data.status
};



export const reviseDates = async (project_idx, start_date, duration) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/revise_dates`, 
        { project_idx:project_idx, start_date:start_date, duration:duration }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });
    return res.data.status
};


export const getProjectDate = async (project_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/get_project_date`, 
        { project_idx:project_idx }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });
    return res.data.content
};


export const getApprovals = async (project_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/get_approvals`, 
        { project_idx:project_idx }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data
};

export const getSectionNames = async () => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.get(`${BASEURL}/get_section_names`,
        {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });
    return res.data.sections
};

export const writeSection = async (project_idx, section_name, rewrite) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/write_section`, 
        { project_idx:project_idx, name:section_name, overwrite:rewrite}, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text
};

export const idea2Project = async (idea_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    
    const res = await axios.post(`${BASEURL}/idea2project`, 
        { idea_idx:idea_idx }, 
        { timeout: TIMEOUT_GENERAL, 
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.project_idx
};

export const getContents = async (project_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/get_contents`, 
        { project_idx:project_idx }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.content
};

export const approveSection = async (project_idx, section_name) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    try {
        const res = await axios.post(`${BASEURL}/approve_section`, 
            { project_idx:project_idx, name:section_name }, 
            { timeout: TIMEOUT_GENERAL,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });

        return res.data.status
    } catch (error) {
        console.error("Failed to approve section:", error);
    }
};

export const disproveSection = async (project_idx, section_name) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    try {
    const res = await axios.post(`${BASEURL}/disprove_section`, 
        { project_idx:project_idx, name:section_name }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.status
} catch (error) {
    console.error("Failed to disprove section:", error);
}
};


export const updateSection = async (project_idx, section_name, new_text) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    //alert(JSON.stringify(new_text));
    
    
    try {
        const res = await axios.post(`${BASEURL}/update_section`, 
            { project_idx:project_idx, name:section_name, text:new_text }, 
            { timeout: TIMEOUT_GENERAL ,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });

        return { status: 'SUCCESS', message: res.data.status };
    } catch (error) {
        // Check if the error is a server response and if the status code is 500
        if (error.response && error.response.status === 500) {
        // Return the server's error message directly
        const serverErrorMessage = error.response.data.message || error.response.data;
        const parts = serverErrorMessage.detail.split(': ');
        const extractedMessage = parts.length > 1 ? parts[1] : serverErrorMessage;
        return { status: 'ERROR', message: extractedMessage };
        }

        // For any other errors (network issues, 4xx, etc.), you can return a generic message
        console.error('An unexpected error occurred:', error);
        return { status: 'ERROR', message: 'An unexpected error occurred. Please try again.' };
  }
};

export const reviseSection = async (project_idx, section_name, user_prompt) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/revise_section`, 
        { project_idx:project_idx, name:section_name, user_prompt:user_prompt }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.text
};

export const approveRevision = async (project_idx, section_name) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/approve_revision`, 
        { project_idx:project_idx, name:section_name }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.status
};

export const deleteRevision = async (project_idx, section_name) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const res = await axios.post(`${BASEURL}/delete_revision`, 
        { project_idx:project_idx, name:section_name }, 
        { timeout: TIMEOUT_GENERAL ,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

    return res.data.status
};

export const exportProject = async (project_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const response = await axios.post(
        `${BASEURL}/export_project`,
        { project_idx: project_idx },
        {
            responseType: 'blob', // Important: tells axios to treat the response as a Blob (binary)
            timeout: TIMEOUT_GENERAL*2,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    // Create a downloadable link
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    // Optional: set filename from headers if provided by backend
    const disposition = response.headers['content-disposition'];
    let filename = 'downloaded_file';
    if (disposition && disposition.includes('filename=')) {
        filename = disposition
            .split('filename=')[1]
            .split(';')[0]
            .replace(/"/g, '')
            .trim();
    }

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};



export const exportGantt = async (project_idx) => {
    const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
    const response = await axios.post(
        `${BASEURL}/export_gantt`,
        { project_idx: project_idx },
        {
            responseType: 'blob', // Important: tells axios to treat the response as a Blob (binary)
            timeout: TIMEOUT_GENERAL*3,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    // Create a downloadable link
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    // Optional: set filename from headers if provided by backend
    const disposition = response.headers['content-disposition'];
    let filename = 'downloaded_file';
    if (disposition && disposition.includes('filename=')) {
        filename = disposition
            .split('filename=')[1]
            .split(';')[0]
            .replace(/"/g, '')
            .trim();
    }

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};